module.exports = __webpack_public_path__ + "7a0684a9c39f8cdfd43f01fdff484539.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-square.png
// module id = 1834
// module chunks = 0